import { render, staticRenderFns } from "./IntegrationConfiguration.vue?vue&type=template&id=35fe02d0"
import script from "./IntegrationConfiguration.vue?vue&type=script&lang=js"
export * from "./IntegrationConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports